import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Col, FormGroup, Row} from "react-bootstrap";
import { Formik, Field } from 'formik';
import { bulkUpdateBillingAddress } from "../../../actions";

const SCOPE_ALL = 'all';
const SCOPE_FROM_DATE = 'from_date';
const SCOPE_ORDER_IDS = 'order_ids';

const trim = (value) => (value === undefined || value === null ? '' : String(value)).trim();

class InternalBillingAddressForm extends React.Component {

  buildPayload(values) {
    const {user} = this.props;

    const payload = {
      user_id: user.id,
      address: {
        street_number: trim(values.street_number),
        street: trim(values.street),
        postal_code: trim(values.postal_code),
        city: trim(values.city),
        additional_information: trim(values.additional_information),
      },
    };

    // Les 3 scopes sont exclusifs : on n'en envoie qu'un seul.
    if (values.scope === SCOPE_FROM_DATE) {
      payload.from_date = values.from_date;
    } else if (values.scope === SCOPE_ORDER_IDS) {
      payload.order_ids = (values.order_ids_raw || '')
        .split(',')
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => Number.isFinite(n));
    } else {
      payload.all = true;
    }

    return payload;
  }

  render() {
    const {user, submit} = this.props;
    if (!user || !user.id) return <span></span>;

    return <div className='BillingAddressForm'>
      <hr />
      <h4>Changer l&apos;adresse de facturation</h4>
      <Formik
        initialValues={{
          scope: SCOPE_ALL,
          from_date: '',
          order_ids_raw: '',
          street_number: '',
          street: '',
          postal_code: '',
          city: '',
          additional_information: '',
        }}
        onSubmit={(values, actions) => {
          submit(this.buildPayload(values));
          actions.setSubmitting(false);
        }}
        render={(props) => (
          <form onSubmit={props.handleSubmit} className="form-horizontal">
            <FormGroup as={Row}>
              <Col sm={12}>
                <label>Commandes concernées</label>
                <Field component="select" name="scope" className="form-control">
                  <option value={SCOPE_ALL}>Toutes</option>
                  <option value={SCOPE_FROM_DATE}>Depuis une date</option>
                  <option value={SCOPE_ORDER_IDS}>IDs précis</option>
                </Field>
              </Col>
            </FormGroup>

            {props.values.scope === SCOPE_FROM_DATE &&
              <FormGroup as={Row}>
                <Col sm={12}>
                  <label>Depuis le</label>
                  <Field type="date" name="from_date" required={true} className="form-control"/>
                </Col>
              </FormGroup>
            }

            {props.values.scope === SCOPE_ORDER_IDS &&
              <FormGroup as={Row}>
                <Col sm={12}>
                  <label>IDs de commandes (séparés par des virgules)</label>
                  <Field type="text" name="order_ids_raw" required={true} placeholder="98213, 98567, 99001" className="form-control"/>
                </Col>
              </FormGroup>
            }

            <FormGroup as={Row}>
              <Col sm={2}>
                <label>Numéro</label>
                <Field type='text' name="street_number" required={true} className="form-control"/>
              </Col>
              <Col sm={10}>
                <label>Rue</label>
                <Field type='text' name="street" required={true} className="form-control"/>
              </Col>
            </FormGroup>
            <FormGroup as={Row}>
              <Col sm={3}>
                <label>Code postal</label>
                <Field type='text' name="postal_code" required={true} className="form-control"/>
              </Col>
              <Col sm={9}>
                <label>Ville</label>
                <Field type='text' name="city" required={true} className="form-control"/>
              </Col>
            </FormGroup>
            <FormGroup as={Row}>
              <Col sm={12}>
                <label>Complément</label>
                <Field type='text' name="additional_information" className="form-control"/>
              </Col>
            </FormGroup>
            <FormGroup as={Row}>
              <Col>
                <button className="btn btn-primary btn-small float-right" type="submit" disabled={props.isSubmitting}>
                  VALIDER
                </button>
              </Col>
            </FormGroup>
          </form>
        )}
      />
    </div>;
  }
}

InternalBillingAddressForm.propTypes = {
  "user": PropTypes.object,
  "submit": PropTypes.func,
};

export const BillingAddressForm = connect(
  (state) => ({
    "user": state.support.user,
  }),
  (dispatch) => ({
    submit: (payload) => dispatch(bulkUpdateBillingAddress(payload)),
  })
)(InternalBillingAddressForm);
